import { createWebHistory, createRouter } from "vue-router";

const routes = [
    {
        path: "/",
        name: "MainPage",
        meta: { requiresAuth: true },
        component: () => import("../views/MainPage/MainPage.vue"),
    },
    {
        path: "/questions",
        name: "QuestionGuide",
        meta: { requiresAuth: true },
        component: () => import("../views/QuestionGuide/QuestionGuide.vue"),
    },
    {
        path: "/feedback",
        name: "FeedbackPage",
        meta: { requiresAuth: true },
        component: () => import("../views/Feedback/FeedbackPage.vue"),
    },
    {
        path: "/help",
        name: "HelpPage",
        meta: { requiresAuth: true },
        component: () => import("../views/HelpPage/HelpPage.vue"),
    },
    {
        path: "/about-us",
        name: "AboutUs",
        meta: { requiresAuth: true },
        component: () => import("../views/AboutUs/AboutUs.vue"),
    },
    {
        path: "/community",
        name: "CommunityPage",
        meta: { requiresAuth: true },
        component: () => import("../views/CommunityPage/CommunityPage.vue"),
    },
    {
        path: "/care-plan",
        name: "CarePlans",
        //meta: { requiresAuth: true },
        component: () => import("../views/CarePlan/CarePlan.vue"),
    },
    {
        path: "/care-plan/:id",
        name: "CarePlan",
        meta: { requiresAuth: true },
        component: () => import("../views/CarePlan/CarePlan.vue"),
    },
    {
        path: "/experts",
        name: "ExpertsView",
        meta: { requiresAuth: true },
        component: () => import("../views/ExpertsView/ExpertsView.vue"),
    },
    {
        path: "/about-surgeries",
        name: "AboutSurgeries",
        // meta: { requiresAuth: true },
        component: () => import("../views/AboutSurgeries/AboutSurgeries.vue"),
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/users/LogIn/LoginPage.vue"),
    },
    {
        path: "/logout",
        name: "Logout",
        component: () => import("../views/users/LogoutPage/LogoutPage.vue"),
    },
    {
        path: "/password/reset",
        name: "PasswordReset",
        component: () => import("../views/users/PasswordReset/PasswordReset.vue"),
    },
    {
        path: "/privacy",
        name: "Privacy",
        component: () => import("../views/PrivacyPage/PrivacyPage.vue"),
    },
    {
        path: "/password/update/:token",
        name: "PasswordUpdate",
        component: () => import("../views/users/PasswordUpdate/PasswordUpdate.vue"),
    },
    {
        path: "/account",
        name: "ProfilePage",
        meta: { requiresAuth: true },
        component: () => import("../views/ProfilePage/ProfilePage.vue"),
    },
    {
        path: "/register",
        name: "RegistrationPage",
        component: () => import("../views/users/RegistrationPage/RegistrationPage.vue"),
    },
    {
        path: "/register/:siteCode",
        name: "RegistrationPageWithSite",
        component: () => import("../views/users/RegistrationPage/RegistrationPage.vue"),
    },
    {
        path: "/demographics",
        name: "DemographicsView",
        meta: { requiresAuth: true },
        component: () => import("../views/DemographicsView/DemographicsView.vue"),
    },
    {
        path: "/update-demographics",
        name: "Update DemographicsView",
        meta: { requiresAuth: true },
        component: () => import("../views/DemographicsView/DemographicsView.vue"),
    },
    {
        path: "/new-care-plan",
        name: "WYSHView",
        meta: { requiresAuth: true },
        component: () => import("../views/WYSHView/WYSHView.vue"),
    },
];

// normalize base to "/" or "/something/"
const normalizeBase = (basePath = "/") => {
    const trimmed = String(basePath || "").replace(/^\/+|\/+$/g, "");
    return trimmed ? `/${trimmed}/` : "/";
};

export const buildRouter = (basePath = "/") => {
    const router = createRouter({
        history: createWebHistory(normalizeBase(basePath)),
        routes,
    });

    router.beforeEach((to, from) => {
        console.log("Navigation initiated:");
        console.log("  From:", from.fullPath);
        console.log("  To:", to.fullPath);
        console.log("  From Name:", from.name);
        console.log("  To Name:", to.name);
        console.log("  To Params:", to.params);
        console.log("  To Query:", to.query);
    });

    return router;
};

// Default export preserved for any legacy imports
export default buildRouter("/");